import type { ReactNode } from 'react';

export const symbol_tile_medium: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-230v-167q0-12.75 8.63-21.38Q137.25-427 150-427h247q12.75 0 21.38 8.62Q427-409.75 427-397v167q0 12.75-8.62 21.37Q409.75-200 397-200H150q-12.75 0-21.37-8.63Q120-217.25 120-230Zm412 0v-167q0-12.75 8.63-21.38Q549.25-427 562-427h248q12.75 0 21.38 8.62Q840-409.75 840-397v167q0 12.75-8.62 21.37Q822.75-200 810-200H562q-12.75 0-21.37-8.63Q532-217.25 532-230ZM120-563v-167q0-12.75 8.63-21.38Q137.25-760 150-760h660q12.75 0 21.38 8.62Q840-742.75 840-730v167q0 12.75-8.62 21.37Q822.75-533 810-533H150q-12.75 0-21.37-8.63Q120-550.25 120-563Zm60 303h187v-107H180v107Zm412 0h188v-107H592v107Zm-318-54Zm412 0Z"
		/>
	</svg>
);
